import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import ChangeCourseFormService from '../services/ChangeCourseFormService';
import ChangeCourseForm from './ChangeCourseForm';
import Async from '../../../core/layout/Async';

class ChangeCourseFormContainer extends Component {
  static propTypes = {
    studentId: PropTypes.string,
  };

  static defaultProps = {
    studentId: null,
  };

  changeCourseFormService = new ChangeCourseFormService();
  componentWillMount() {
    this.changeCourseFormService.handleLoad(this.props.studentId);
  }

  render() {
    return (
      <Async fetching={this.changeCourseFormService.fetch.fetching}>
        <ChangeCourseForm
          onSubmit={this.changeCourseFormService.handleSubmit}
          onChange={this.changeCourseFormService.form.setValue}
          onReset={this.changeCourseFormService.form.reset}
          values={this.changeCourseFormService.form.getValues()}
          errors={this.changeCourseFormService.form.errors}
          submitting={this.changeCourseFormService.submit.fetching}
          isDirty={this.changeCourseFormService.form.isDirty}
        />
      </Async>
    );
  }
}

export default observer(ChangeCourseFormContainer);
